"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InnerWrapper = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactPopper = require("react-popper");
var _hooks = require("../../hooks");
var _Portal = _interopRequireDefault(require("../Portal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Cross = function Cross(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.646 36.647a.5.5 0 0 0 .708.707L19 19.707l17.647 17.647a.5.5 0 0 0 .707-.707L19.707 19 37.354 1.354a.5.5 0 0 0-.707-.708L19 18.293 1.354.646a.502.502 0 0 0-.708.708L18.293 19 .646 36.647z"
  }));
};
Cross.defaultProps = {
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#919499",
  fillRule: "evenodd",
  clipRule: "evenodd"
};
var Bubble = function Bubble(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type,
    text = _ref.text,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'min' : _ref$width,
    _ref$flip = _ref.flip,
    flip = _ref$flip === void 0 ? true : _ref$flip,
    children = _ref.children,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? false : _ref$closeable,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$renderExtras = _ref.renderExtras,
    renderExtras = _ref$renderExtras === void 0 ? function () {
      return null;
    } : _ref$renderExtras,
    _ref$preventOverflow = _ref.preventOverflow,
    preventOverflow = _ref$preventOverflow === void 0 ? true : _ref$preventOverflow,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$permanent = _ref.permanent,
    permanent = _ref$permanent === void 0 ? false : _ref$permanent,
    _ref$noWrap = _ref.noWrap,
    noWrap = _ref$noWrap === void 0 ? false : _ref$noWrap,
    _ref$eventType = _ref.eventType,
    eventType = _ref$eventType === void 0 ? 'hover' : _ref$eventType,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$shouldStopPropag = _ref.shouldStopPropagation,
    shouldStopPropagation = _ref$shouldStopPropag === void 0 ? true : _ref$shouldStopPropag;
  var wrapper = (0, _react.useRef)(null);
  var popperElement = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var innerRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    arrowElement = _useState4[0],
    setArrowElement = _useState4[1];
  var hoverHandler = function hoverHandler(event) {
    if (eventType !== 'hover') {
      return;
    }
    if (permanent) {
      return;
    }
    if (event.type === 'mouseenter') {
      setShow(true);
    } else if (event.type === 'mouseleave' && !closeable) {
      setShow(false);
    }
  };
  var clickHandler = function clickHandler(e) {
    if (shouldStopPropagation) {
      e.stopPropagation();
    }
    if (eventType !== 'click') {
      return;
    }
    setShow(true);
  };
  var closeHandler = function closeHandler() {
    return permanent ? null : setShow(false);
  };
  (0, _hooks.useOnClickOutside)(wrapper, closeHandler);
  var _usePopper = (0, _reactPopper.usePopper)(innerRef.current, popperElement.current, {
      placement: placement,
      modifiers: [{
        name: 'flip',
        enabled: flip
      }, {
        name: 'arrow',
        options: {
          element: arrowElement,
          padding: 6
        }
      }, {
        name: 'offset',
        options: {
          offset: [0, 10]
        }
      }, {
        name: 'preventOverflow',
        enabled: preventOverflow,
        options: {
          padding: 8
        }
      }]
    }),
    styles = _usePopper.styles,
    state = _usePopper.state,
    forceUpdate = _usePopper.forceUpdate;
  (0, _react.useEffect)(function () {
    if (typeof forceUpdate === 'function') {
      // https://github.com/floating-ui/react-popper/issues/458#issuecomment-1658120586
      Promise.resolve().then(forceUpdate);
    }
  }, [width, text, title, closeable, forceUpdate]);
  var isVisible = (0, _react.useCallback)(function () {
    if (permanent) {
      return true;
    }
    return Boolean(show && !disabled && (text || title));
  }, [permanent, show, disabled, text, title]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    ref: wrapper,
    className: className,
    onMouseEnter: hoverHandler,
    onMouseLeave: hoverHandler,
    onTouchStart: function onTouchStart() {
      return setShow(true);
    },
    onClick: clickHandler,
    isClickable: eventType === 'click',
    inline: inline
  }, noWrap ? ( /*#__PURE__*/_react["default"].cloneElement(_react["default"].Children.only(children), {
    ref: innerRef
  })) : /*#__PURE__*/_react["default"].createElement(InnerWrapper, {
    ref: innerRef
  }, /*#__PURE__*/_react["default"].cloneElement(_react["default"].Children.only(children))), isVisible() ? /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    type: type,
    width: width,
    ref: popperElement,
    style: styles.popper,
    placement: state === null || state === void 0 ? void 0 : state.placement
  }, /*#__PURE__*/_react["default"].createElement(Flex, null, /*#__PURE__*/_react["default"].createElement(TextBlock, null, title && /*#__PURE__*/_react["default"].createElement(Title, null, title), text && /*#__PURE__*/_react["default"].createElement(Text, null, text)), closeable && /*#__PURE__*/_react["default"].createElement(CloseButton, {
    onClick: closeHandler
  }, /*#__PURE__*/_react["default"].createElement(Cross, {
    width: "100%",
    height: "100%"
  }))), renderExtras(), /*#__PURE__*/_react["default"].createElement(Arrow, {
    type: type,
    placement: state === null || state === void 0 ? void 0 : state.placement,
    style: styles.arrow,
    ref: setArrowElement
  }))) : null);
};
var WIDTH_MAP = {
  max: (0, _styledComponents.css)(["width:420px;"]),
  normal: (0, _styledComponents.css)(["width:240px;"]),
  min: (0, _styledComponents.css)(["max-width:240px;"])
};
var StyledBubble = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__StyledBubble",
  componentId: "sc-eczdkd-0"
})(["z-index:99999;position:relative;padding:8px;box-shadow:0 2px 20px 0 rgba(191,191,172,0.5);border-radius:", ";", ";background-color:", ";", ";&:before{content:'';position:absolute;", " ", "}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadiusBig;
}, function (_ref3) {
  var width = _ref3.width;
  return Number.isInteger(width) ? (0, _styledComponents.css)(["width:", "px;"], width) : WIDTH_MAP[width];
}, function (_ref4) {
  var theme = _ref4.theme,
    type = _ref4.type;
  return theme.elements.tooltip[type];
}, function (_ref5) {
  var placement = _ref5.placement;
  return placement && (0, _styledComponents.css)(["", ":100%;border-", "-color:white;"], placement, placement);
}, function (_ref6) {
  var placement = _ref6.placement;
  return (placement === 'top' || placement === 'bottom') && (0, _styledComponents.css)(["width:100%;height:10px;left:0;", ":100%;"], placement);
}, function (_ref7) {
  var placement = _ref7.placement;
  return (placement === 'left' || placement === 'right') && (0, _styledComponents.css)(["width:10px;height:100%;top:0;", ":100%;"], placement);
});
var Title = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__Title",
  componentId: "sc-eczdkd-1"
})(["font-family:'ONYOneFont','Helvetica',sans-serif;font-size:14px;font-weight:bold;line-height:16px;margin-bottom:2px;"]);
var Text = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__Text",
  componentId: "sc-eczdkd-2"
})(["font-family:'ONYOneFont','Helvetica',sans-serif;font-size:12px;white-space:pre-line;"]);
var Flex = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__Flex",
  componentId: "sc-eczdkd-3"
})(["display:flex;flex-direction:", ";"], function (_ref8) {
  var direction = _ref8.direction;
  return direction;
});
var TextBlock = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__TextBlock",
  componentId: "sc-eczdkd-4"
})(["display:flex;flex-direction:column;flex-grow:1;"]);
var CloseButton = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__CloseButton",
  componentId: "sc-eczdkd-5"
})(["flex-shrink:0;appearance:none;display:inline-flex;background:none;border:none;width:16px;height:16px;margin-left:8px;"]);
var Arrow = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__Arrow",
  componentId: "sc-eczdkd-6"
})(["position:absolute;margin:auto;width:0;height:0;border:10px solid transparent;pointer-events:none;", ""], function (_ref9) {
  var placement = _ref9.placement,
    type = _ref9.type;
  return placement && (0, _styledComponents.css)(["", ":100%;border-", "-color:", ";"], placement, placement, function (_ref10) {
    var theme = _ref10.theme;
    return theme.elements.tooltip[type];
  });
});
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__Wrapper",
  componentId: "sc-eczdkd-7"
})(["display:", ";", ""], function (_ref11) {
  var inline = _ref11.inline;
  return inline ? 'inline-flex' : 'flex';
}, function (_ref12) {
  var isClickable = _ref12.isClickable;
  return isClickable ? 'cursor: pointer;' : null;
});
var InnerWrapper = exports.InnerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Bubble__InnerWrapper",
  componentId: "sc-eczdkd-8"
})(["display:flex;justify-content:center;align-items:center;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Bubble);